import React, { useState, useEffect } from 'react'
import { codeToHtml } from 'shiki'
import LoadingSpinner from './LoadingSpinner'

interface SyntaxHighlighterProps {
  language: string;
  children: React.ReactNode;
}

const SyntaxHighlighter: React.FC<SyntaxHighlighterProps> = ({ language, children }) => {
  const [html, setHtml] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const highlight = async () => {
      setIsLoading(true)
      try {
        const highlighted = await codeToHtml(String(children), {
          lang: language,
          theme: 'material-theme-ocean',
        })
        setHtml(highlighted)
      } catch (error) {
        console.error(`Shiki highlighting failed for lang ${language}:`, error)
        // Fallback to plain text in a pre block with styling
        setHtml(`<pre class="shiki material-theme-ocean" style="background-color: #0F111A; color: #8F93A2"><code>${String(children)}</code></pre>`)
      } finally {
        setIsLoading(false)
      }
    }
    highlight()
  }, [children, language])

  if (isLoading) {
    return (
      <div className="bg-gray-100 p-4 rounded-md my-4">
        <LoadingSpinner />
      </div>
    )
  }

  // This div wrapper prevents ReactMarkdown from adding extra <p> tags around code blocks
  return <div dangerouslySetInnerHTML={{ __html: html }} />
}

export default SyntaxHighlighter